<div class="page_container">
    <ui-page-header [title]="'custom_fields.custom_fields' | translate" [lucideIcon]="'Code'">
      <ui-button 
        type="primary" 
        [label]="('custom_fields.new_field' | translate | uppercase)"
        icon="plus-cc"
        iconSize="large"
        iconPosition="start"
        (click)="addCustomField()">
      </ui-button>
    </ui-page-header>
    <div class="table_card">
      <div class="custom-fields-content">
        <table class="custom-fields-table">
          <thead>
            <tr
              class="row header"
            >
              <th>{{ "custom_fields.listing.field" | translate }}</th>
              <th>{{ "custom_fields.listing.technical_name" | translate }}</th>
              <th>{{ "custom_fields.listing.related_object" | translate }}</th>
              <th>{{ "custom_fields.listing.field_type" | translate }}</th>
              <th>{{ "custom_fields.listing.visibility" | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody class="table_body" (scroll)="onScroll($event)">
            <ng-container *ngFor="let customField of customFields$ | async">
              <tr class="row">
                  <td>{{ getLabel(customField) }}</td>
                  <td>{{ customField.technical_name }}</td>
                  <td>
                    <span
                      class="tag truncate"
                      [title]="customField.object_type"
                    >
                      {{ customField.object_type }}
                    </span>
                  </td>
                  <td>{{ 'custom_fields.field_types.' + customField.field_type | translate }}</td>
                  <td>{{ getVisibilityLabel(customField.visibility) }}</td>
                  <td>
                    <div class="actions">
                      <button
                        type="button"
                        class="icon_action"
                        (click)="addCustomField(customField)"
                        [attr.aria-label]="'common.edit' | translate">
                        <ui-icon name="Settings" size="large"></ui-icon>
                      </button>
                      <button
                        type="button"
                        class="icon_action icon_action--danger"
                        (click)="deleteCustomField(customField.id)"
                        [attr.aria-label]="'common.delete' | translate">
                        <ui-icon name="Trash2" size="large"></ui-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
          </tbody>
        </table>
      </div>
    </div>
</div>